import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://vlnjcxydwhacxrkmyhlb.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsbmpjeHlkd2hhY3hya215aGxiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwMTg0OTIsImV4cCI6MjA3MDU5NDQ5Mn0.5O-dhOPyt8CioasawrVDaCsKAGzgphQjmaoqmHYVZsc'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)


